import { Action } from './DataGridProps';

const defaultActions: Action<unknown>[] = ['clear-filters', 'refresh-data', 'column-chooser'];

export default defaultActions;
